import getLocalString from "constants/Localization";
import {
  GetOrganizationEmailIdentityDocument,
  useDeleteOrganizationEmailIdentityMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteOrganizationEmailIdentity() {
  const [mutation, { data, loading, error }] = useDeleteOrganizationEmailIdentityMutation({
    refetchQueries: [{ query: GetOrganizationEmailIdentityDocument }],
  });

  return useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteOrganizationEmailIdentity",
    },
    {
      successMessage: getLocalString("emailIdentity.delete-success"),
      failureMessage: getLocalString("emailIdentity.delete-failure"),
    }
  );
}
